var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{staticClass:"act-container",attrs:{"loading":_setup.initialLoading,"empty":_setup.isEmpty}},[_c(_setup.CScrollPro,{ref:"scrollRef",attrs:{"pullDown":"","pullUp":"","moreData":_setup.hasMoreData},on:{"pull-down":_setup.onPullDown,"pull-up":_setup.onPullUp}},[_c('div',{staticClass:"act-content"},_vm._l((_setup.finalData),function(item,index){return _c(_setup.CCardSymbol,{key:index,attrs:{"isShowCoverPicture":false,"item":item,"formatter":() => ({
						subject: item.title,
						imageUrl: _setup.isResearch(item) ? '' : item.logo43,
						date: _setup.formatActivityDate(item)
					})}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }